// extracted by mini-css-extract-plugin
export default {"container":"SectionHeader_container__y+Qsm","inner":"SectionHeader_inner__CN1Ze"};